import { TipoEmpresa } from './tipo-empresa';
import { CategoriaEmpresa } from './categoria-empresa';

export class EstruturaUnidade {

	id:number;
	descricao:string;
	quantidade:number;
}

